require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-apply-the-default-bootstrap-button-style.json") })
        }
      }, "path---front-end-libraries-bootstrap-apply-the-default-bootstrap-button-style");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-apply-the-default-bootstrap-button-style!./.cache/json/front-end-libraries-bootstrap-apply-the-default-bootstrap-button-style.json
// module id = 1990
// module chunks = 231608221292675